import http from '../../../utils/http';
import SubmissionError from '../../../error/SubmissionError';
import se from '../../../error/SubmissionError';

const state = {
	loading: false,
	error: null
};

const getters = {
	loading: function() {
		return state.loading;
	},
  error: function() {
    return state.error;
  }
};

const actions = {
	sendPassword({commit}, values) {

    commit('NEW_PASSWORD_LOADING', true);
		commit('NEW_PASSWORD_ERROR', null);
		return http.fetch('/users/new-password/' + values.identifier, {method: 'PUT', body: JSON.stringify({"plainPassword": values.password})})
			   .then(function(response){ return response.json() })
			   .then(function(data) {
				   commit('NEW_PASSWORD_LOADING', false);
				   return true;
				})
				.catch(e => {					
					commit('NEW_PASSWORD_LOADING', false);
					if (e instanceof SubmissionError) {
            commit('NEW_PASSWORD_ERROR', e.errors.plainPassword);
					}
					else {
						commit('NEW_PASSWORD_ERROR', "Token nieważny");
					}
					return false;
				});
	},
};

const mutations = {
	NEW_PASSWORD_LOADING(state, payload){
		state.loading = payload;
	},
    NEW_PASSWORD_ERROR(state, payload){
    state.error = payload;
  }
};

export default {
	namespaced: true,
	getters,
	state,
	actions,
	mutations
};
  


// WEBPACK FOOTER //
// ./src/store/modules/security/newPassword.js